import type { AnalyticsEvent } from './types';

const getPrefixedEvent = (
  prefix: string,
  { event, action, label }: AnalyticsEvent,
) => {
  const prefixedEventName = `${prefix}_${event}`;
  return {
    event: prefixedEventName,
    action,
    label,
  };
};

export const analyticsLib = { getPrefixedEvent };
